function o(r) {
  const t = r.substring(1);
  return "cq" + t.substring(0, 1).toUpperCase() + t.substring(1);
}
const p = (r = {}) => {
  if (!r || !Object.keys(r).length)
    return;
  const t = Object.getOwnPropertyNames(r);
  return Object.fromEntries(t.map((s) => [
    s.startsWith(":") ? o(s) : s,
    r[s] ?? ""
  ]));
};
export {
  p as m
};
